import { render, staticRenderFns } from "./BulkTypeIn.vue?vue&type=template&id=cd8b570a&scoped=true"
import script from "./BulkTypeIn.vue?vue&type=script&lang=js"
export * from "./BulkTypeIn.vue?vue&type=script&lang=js"
import style0 from "./BulkTypeIn.vue?vue&type=style&index=0&id=cd8b570a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd8b570a",
  null
  
)

export default component.exports